
const Media = {

  processMedia: (loadedConfiguration = {}, media = {}) => {
    const { progressive: shouldReproduceInProgressive = false, displayTitle = false } = loadedConfiguration;
    const processedMedia = {
      file: (shouldReproduceInProgressive ? media.progressive : media.m3u8) ?? null,
      image: media.thumbnail?.url ?? null,
      duration: media.duration ?? 0,
      title: (displayTitle ? media.title : null) ?? null,
      progressive: media.progressive ?? null,
    };

    return processedMedia;
  },

};

// const Media = {

//   // REVIEW PATCHes https, old_ios, avoid_cache, ...
// processMedia: (loadedConfiguration = {}, media = {}) => {
//  const { progressive: shouldReproduceInProgressive = false, displayTitle = false } = loadedConfiguration;
//  const processedMedia = {
//    file: (shouldReproduceInProgressive ? media.progressive : media.m3u8) ?? null,
//    image: media.thumbnail?.url ?? null,
//    duration: media.duration ?? 0,
//    title: (displayTitle ? media.title : null) ?? null,
//    progressive: media.progressive ?? null,
//    tracks: [{
//      file: media.storyboard ?? null,
//      kind: 'thumbnails',
//    }],

//    // NOTE bloque para construir auxiliar data ignorado por custom-3-player
//    srcType: media.type ?? null,
//    chapters: media.chapter?.url ?? [],   // ?? null
//    captions: (media.subtitles?.map( media_has_subtitle => ({
//      url: media_has_subtitle.subtitle?.url ?? media_has_subtitle.url,
//      label: media_has_subtitle.languageTag ?? media_has_subtitle.name,
//    }))) || [],

//  };
//  if( media.chapter) {
//    processedMedia.tracks.push({
//      file: media.chapter.url ?? null,
//      kind: 'chapters',
//    });
//  }
//  if( media.subtitles) media.subtitles.forEach( media_has_subtitle => {
//    processedMedia.tracks.push({
//      file: media_has_subtitle.subtitle?.url ?? media_has_subtitle.url ?? null,
//      label: media_has_subtitle.languageTag ?? media_has_subtitle.name,
//      kind: 'captions',
//    });
//  });

//  return processedMedia;
// },

// };

export default Media;
